import * as yup from "yup"

export const getPattiValidationSchema = (isDemandPatti: boolean) =>
  yup.object().shape({
    commodity: yup.object().nullable().required("Commodity is required"),
    commodity_variety: yup.object().nullable().required("Variety is required"),
    start_date_time: yup.date().required("Start date is required"),
    quantity_unit: yup.object().nullable().required("Unit is required"),
    officer: yup.object().nullable().required("Senior Officer is required"),
    // junior_officer: yup
    //   .object()
    //   .nullable()
    //   .required("Junior Officer is required"),

    seller: yup.mixed().when([], {
      is: () => isDemandPatti,
      then: schema =>
        schema.test(
          "seller-validation",
          "Supplier is required",
          function (value) {
            const { seller_file, seller_external } = this.parent
            // Valid if either seller is selected (and not empty array if array) OR seller_file is uploaded
            const hasSeller =
              (value && (Array.isArray(value) ? value.length > 0 : true)) ||
              (seller_external && Array.isArray(seller_external)
                ? seller_external.length > 0
                : true)
            const hasFile = !!seller_file
            return hasSeller || hasFile
          }
        ),
      otherwise: schema => schema.nullable(),
    }),
    buyer: yup.mixed().when([], {
      is: () => !isDemandPatti, // Offer Patti
      then: schema =>
        schema.test("buyer-validation", "Buyer is required", function (value) {
          const { buyer_file, buyer_external } = this.parent
          // Valid if either buyer is selected OR buyer_file is uploaded
          const hasBuyer =
            (value && (Array.isArray(value) ? value.length > 0 : true)) ||
            (buyer_external && Array.isArray(buyer_external)
              ? buyer_external.length > 0
              : true)
          const hasFile = !!buyer_file
          return hasBuyer || hasFile
        }),
      otherwise: schema => schema.nullable(),
    }),
    trade_items: yup
      .array()
      .of(
        yup.object().shape({
          variety_grade: yup.object().nullable().required("Grade is required"),
          quantity: yup
            .number()
            .transform((value, originalValue) =>
              originalValue === "" ? undefined : value
            )
            .required("Quantity is required"),
        })
      )
      .min(1, "At least one trade item is required"),
  })
